/* ----------------------------------------------------------------- */
/* Scroll-driven reveals — UI/UX refresh 2026                        */
/* IntersectionObserver-based fade/slide-in. Pairs with `.reveal-*`  */
/* CSS classes defined in base.css. Auto-targets common patterns +   */
/* respects [data-reveal] opt-in. Skipped when prefers-reduced-motion */
/* ----------------------------------------------------------------- */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var AUTO_SELECTORS = [
    '.product-card-wrapper',
    '.collection-card-wrapper',
    '.featured-collection__heading',
    '.section-header',
    '.card-callout',
    '.images-with-text__content',
    '.images-with-text__media',
    '.multi-column-text__column',
    '.hero__content',
    '.featured-articles__article',
    '.banner-fullwidth__content',
    '.newsletter__content'
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function attach(el) {
    if (el.classList.contains('reveal-init')) return;
    // Skip header/footer/announcement so above-fold chrome stays static
    if (el.closest('.header, .footer, .announcement-bar, .cart-drawer, .modal')) return;
    el.classList.add('reveal-init');

    var rect = el.getBoundingClientRect();
    var inView = rect.top < window.innerHeight && rect.bottom > 0;

    if (inView) {
      // Already on screen at load → trigger entrance on next frames
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-revealed');
        });
      });
    } else {
      observer.observe(el);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-reveal]').forEach(attach);
    scope.querySelectorAll(AUTO_SELECTORS).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Re-scan when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
